// extracted by mini-css-extract-plugin
export default {"root":"AllocationModal_root__yVuDz","summary":"AllocationModal_summary__1rgR0","error":"AllocationModal_error__e7aKQ","info":"AllocationModal_info__pK8nO"};